module.exports = __webpack_public_path__ + "static/media/pipeline_light.9b20cdc0.png";